/**
 * stepMillisecond is a min delta time in milliseconds, which is needed to change the multiplier value.
 */
import Config from "@/config/Config";
import Facade from "@/Facade";


const defaultStepMillisecond = 100;
let stepMillisecond = defaultStepMillisecond

function setStep(value) {
    stepMillisecond = Math.max(value, defaultStepMillisecond);
}
/**
 * this function is based on math function
 * m = (100 + t^2)/100
 * dt = 1 second
 * dm = multiplier * 100,
 * where multiplier is a floating point number with two digits after dot.
 *
 * @param {number} time - amount of milliseconds passed from round start till now (current time - round start time).
 * @return {number} Return multiplier - a floating point number with two digits after dot.
 */
function calculateMultiplier(time) {
    const tmf = Math.floor(time / stepMillisecond) * stepMillisecond;
    const dt = tmf / 1000;
    return Math.floor((1 + Math.pow(dt/10, 2) + Math.pow(dt/38,4)) * 100 + 0.5) / 100;
}

/**
 *
 * @param {number} startTime - round start time in milliseconds.
 * @param {number} currentTime - current time in milliseconds.
 * @return {number} Return multiplier.
 */
function calculateRoundMultiplier(startTime, currentTime) {
    return calculateMultiplier(Math.max(0, currentTime - startTime))
}

function calculateTimeForExplosion(time) {
    return Math.min(time, Config.DefaultTimeForExplosion)
}

function calculateTimeToMakeBets(time, timeForExplosion) {
    return Math.max(0, time - timeForExplosion)
}


export {
    setStep,
    calculateRoundMultiplier,
    calculateMultiplier,
    calculateTimeToMakeBets,
    calculateTimeForExplosion
}
